import { ChoicesArticleCombination } from "@generated"

export function getRelatedCombinationUrl(
  categoryUrl: string,
  combinationId: string,
  item: ChoicesArticleCombination
) {
  return `${categoryUrl}/c-${combinationId}-${item.slug}-${item.id}`
}
